import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../../lib/api";

export const inputCls = "w-full border border-slate-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#970C10]/30";
export const labelCls = "block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1";

/**
 * Small reusable "Generate with AI" button. Renders a spark icon, on click
 * calls /admin/ai/generate with the given `kind` + `subject`, then invokes
 * `onGenerated(text)` so the parent editor can drop it into the target field.
 */
export function AiAssistButton({ kind, subject, provider = "claude", tone = "informative and slightly punchy", context = "", onGenerated, label = "Generate" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!subject) { toast.error("Fill the subject/slug first"); return; }
    setBusy(true);
    try {
      const { data } = await adminApi().post("/admin/ai/generate", { kind, subject, tone, context, provider });
      onGenerated?.(data.text);
      toast.success(`Generated (${provider})`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Generation failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={`ai-gen-${kind}`}
      className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#970C10] hover:text-[#7A0A0D] disabled:opacity-40 transition-colors duration-200">
      <Sparkles className="w-3 h-3" /> {busy ? "…" : `AI ${label}`}
    </button>
  );
}
